import { useTranslation } from 'react-i18next'
import { OrganizationAddressSectionCard } from '@/features/organization-settings/components/organization-address-section-card'
import { OrganizationCompanySaveActions } from '@/features/organization-settings/components/organization-company-save-actions'
import { ContentSection } from '@/features/settings/components/content-section'
import { useSupplierOrganizationForm } from '@/features/suppliers/context/supplier-organization-form-context'

export function SupplierOrganizationAddressPage() {
  const { t } = useTranslation(['installations', 'common'])
  const {
    addressState,
    countryName,
    doesRequireLocalAddress,
    latinErrorMessage,
    isSaving,
    isSaveDisabled,
    saveDisabledHint,
    onCountryChange,
    onSingleCountryAddressInput,
    onCnEnglishAddressInput,
    onCnLocalAddressInput,
    onSaveChanges,
  } = useSupplierOrganizationForm()

  return (
    <ContentSection
      title={t('installations:suppliers.edit.pages.address.title')}
      desc={t('installations:suppliers.edit.pages.address.description')}
    >
      <div className="space-y-6">
        <OrganizationAddressSectionCard
          key={doesRequireLocalAddress ? 'local-address' : 'single-address'}
          state={addressState}
          countryName={countryName}
          doesOrganizationRequiresLocalAddress={doesRequireLocalAddress}
          latinErrorMessage={latinErrorMessage}
          showRequiredIndicators={false}
          countryEditable
          variant="plain"
          onCountryChange={onCountryChange}
          countryPlaceholder={t('installations:suppliers.dialog.countryPlaceholder')}
          onSingleCountryAddressInput={onSingleCountryAddressInput}
          onCnEnglishAddressInput={onCnEnglishAddressInput}
          onCnLocalAddressInput={onCnLocalAddressInput}
        />

        <OrganizationCompanySaveActions
          saveLabel={t('common:actions.save', { ns: 'common' })}
          isSaving={isSaving}
          isSaveDisabled={isSaveDisabled}
          saveDisabledHint={saveDisabledHint}
          onSave={onSaveChanges}
        />
      </div>
    </ContentSection>
  )
}
